export default __webpack_public_path__ + "static/media/solteiroduplo_4.b6b1e186.jpg";